import { render } from "./IdleTimeout.vue?vue&type=template&id=10c7eb66&ts=true"
import script from "./IdleTimeout.ts?vue&type=script&lang=ts&external"
export * from "./IdleTimeout.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__